import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Col } from "react-bootstrap";
import revenueOverview from "assets/images/icons/revenueOverview.svg";
import dollar from "assets/images/icons/dollar.svg";
import Riyal from "assets/images/icons/riyal.svg";
import averageBooking from "assets/images/icons/averageBooking.svg";
import info2 from "assets/images/icons/info2.svg";
import averageBookingTooltip from "assets/images/averageBookingTooltip.png";

const RevenueOverview = () => {
  const { t } = useTranslation();
  const { overviewDashboard } = useSelector((state) => state.Dashboards);
  const [showTooltip, setShowTooltip] = useState(false);
  const tooltipRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (tooltipRef.current && !tooltipRef.current.contains(event.target)) {
        setShowTooltip(false);
      }
    };

    if (showTooltip) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showTooltip]);

  return (
    <Col lg={12}>
      <div className="inner_section">
        <div className="title_section">
          <img src={revenueOverview} alt="" width={24} height={24} />
          <h2 className="fs_20 text_black">{t("Revenue Overview")}</h2>
        </div>
        <div className="sub_items">
          <div className="single_item">
            <img src={dollar} width={24} height={24} alt="dollar" />
            <h2 className="fs_14 text_black mt-2">{t("Total Revenue")}</h2>
            <div className="d-flex align-items-center gap-2 mt-4">
              <img src={Riyal} width={17} height={19} alt="riyal" />
              <h2 className="fs_24 text_black ">
                {overviewDashboard?.customers?.totalRevenue?.toLocaleString(
                  "en-US"
                )}
              </h2>
            </div>
          </div>
          <div className="single_item">
            <img src={averageBooking} width={24} height={24} alt="dollar" />
            <div className="g_between position-relative" ref={tooltipRef}>
              <h2 className="fs_14 text_black mt-2">{t("Average Booking")}</h2>
              <img
                src={info2}
                width={16}
                height={16}
                alt="info"
                className="c_p"
                onClick={() => setShowTooltip(!showTooltip)}
              />
              {showTooltip && (
                <img
                  src={averageBookingTooltip}
                  width={450}
                  height={580}
                  alt="info"
                  className="c_p tooltip_img"
                />
              )}
            </div>
            <div className="d-flex align-items-center gap-2 mt-4">
              <img src={Riyal} width={17} height={19} alt="riyal" />
              <h2 className="fs_24 text_black ">
                {overviewDashboard?.customers?.averageBookingsPerDay?.toLocaleString(
                  "en-US"
                )}
              </h2>
            </div>
          </div>
        </div>
      </div>
    </Col>
  );
};

export default RevenueOverview;
